import { combineReducers } from 'redux';
import { reportReducer } from './report/redux';
import { detailsReducer } from './details/redux';

export const checksReportReducer = combineReducers({ reportReducer, detailsReducer });
